module.exports = __webpack_public_path__ + "img/bg-4@2x.bc1522f2.png";